import ApiService from "service/Api";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";
import {
  ReleaseVoucherPayloadTypes,
  VoucherPayloadTypes,
} from "utilities/types/Voucher";

const RaffleAncolMonthService = {
  getAllReward: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        is_voucher: 2,
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
        portal: "admin",
      },
      url: "admin/catalogs",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeReward: async (payload: VoucherPayloadTypes) => {
    const {
      voucherName,
      pointsNeeded,
      voucherImage,
      voucherImageDetail,
      expiryDate,
      voucherType,
      merchant,
      pointTypeUsed,
      tenantId,
      isActive,
      maxClaim,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_name: voucherName,
        points_needed: pointsNeeded,
        image: voucherImage,
        image_detail: voucherImageDetail,
        expiry_date: expiryDate,
        catalog_type: voucherType,
        is_voucher: 2,
        catalog_product: merchant,
        point_type_used: pointTypeUsed,
        tenant_id: tenantId,
        is_active: isActive,
        max_claim: maxClaim,
      },
      url: "admin/catalogs",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateReward: async (voucherId: string, payload: VoucherPayloadTypes) => {
    const {
      voucherName,
      pointsNeeded,
      voucherImage,
      voucherImageDetail,
      expiryDate,
      voucherType,
      merchant,
      pointTypeUsed,
      tenantId,
      isActive,
      maxClaim,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_name: voucherName,
        points_needed: pointsNeeded,
        image: voucherImage,
        image_detail: voucherImageDetail,
        expiry_date: expiryDate,
        catalog_type: voucherType,
        is_voucher: 2,
        catalog_product: merchant,
        point_type_used: pointTypeUsed,
        tenant_id: tenantId,
        is_active: isActive,
        max_claim: maxClaim,
        _method: "PUT",
      },
      url: "admin/catalogs/" + voucherId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteReward: async (voucherId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "admin/catalogs/" + voucherId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateRewardDescription: async (payload: CatalogDescriptionPayloadTypes) => {
    const {
      catalogId,
      title,
      termsAndCondition,
      purcaseAndUse,
      titleEn,
      termsAndConditionEn,
      purcaseAndUseEn,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_id: catalogId,
        title: title,
        terms_and_condition: termsAndCondition,
        purcase_and_use: purcaseAndUse,
        title_en: titleEn,
        terms_and_condition_en: termsAndConditionEn,
        purcase_and_use_en: purcaseAndUseEn,
        _method: "PUT",
      },
      url: "admin/catalogs-description",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  releaseReward: async (payload: ReleaseVoucherPayloadTypes) => {
    const { phoneNumber, voucherCode } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        phone_number: phoneNumber,
        voucher_code: voucherCode,
      },
      url: "admin/catalogs/release-voucher",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default RaffleAncolMonthService;
